import { DatePipe } from "@angular/common";
import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    TemplateRef,
    ViewChild
} from "@angular/core";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as fromRootStore from "../../../reducers";
import {
    Combo2Service,
    ExcelService,
    ReportService
} from "../../../services/index";
declare var google;

@Component({
  selector: "stock-report",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./StockReport.html",
})
export class StockReport implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  gridOptions: any;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();
  brandList = [];
  data: any;
  viewTypeList = ["GRID", "TILE"];
  groupbyList = [
    "DESIGN NO",
    "DESIGN COLOR",
    "COLOR",
    "BRAND",
    "STYLE",
    "TYPE",
    "BARCODE",
  ];
  tileViewGroup = ["DESIGN NO", "DESIGN COLOR"];
  styleList = [];
  designData: any;
  typeList = [];
  stockList = ["ALL", "IN STOCK", "NO STOCK"];
  stockTypeList = ["FRESH", "DAMAGE"];
  actionList = ["YES", "NO"];
  colorList = [];
  qualityList = [];
  fitList = [];
  designList = [];
  coreList = ["CORE", "NEW"];
  brands: boolean;

  newDesignList = [];
  coreDesignList = [];
  listSelected = [];
  newlistSelected = [];
  brandSelected = [];
  dataList: any[];
  exceldata: any;
  view: false;
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;

  filter = {
    season_id: 0,
    stock: "ALL",
    ageing: "",
    stocktype: "FRESH",
    viewtype: "GRID",
    groupby: "BRAND",
    sizecols: "YES",
    fin_id: 3,
    brand: [],
    style: [],
    type: [],
    fit: [],
    stockArray: [],
    quality: [],
    color: [],
    design: [],
    new_design_no: [],
    coreArray: [],
    design_type: "",
    design_above: false,
    design_below: false,
    estindicate: false,
  };
  page = {
    limit: 100,
    count: 0,
    offset: 0,
    orderBy: "agent",
    orderDir: "asc",
  };
  printConfig: any = {
    title: "Agent Yearly report",
    columns: [],
    rows: [],
  };
  viewType = "GRID";
  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;
  @ViewChild("partyDataTable") partyDataTable;

  columns = [];
  toggleCol = [];

  filterExpand = false;
  filterData: any = {
    name: "",
    //company_id: 0
  };
  flag: boolean = false;

  constructor(
    public store: Store<fromRootStore.State>,
    private dp: DatePipe,
    private reportService: ReportService,
    private excelService: ExcelService,
    public toasterService: ToasterService,
    private combo: Combo2Service
  ) {}

  cellClicked(cell, prop, row, col) {
    //
  }

  ngOnInit(): void {
    this.brandCombo();
    this.styleCombo();
    this.fitCombo();
    this.qualityCombo();
    this.colorCombo();
    this.typeCombo();
    this.newDesignCombo();
    this.coreDesignCombo();
    this.columns = [];
    this.gridOptions = {
      columns: this.columns,
      loading: true,
      data: [],
    };
    this.toggleCol = Object.assign({}, this.columns);
    this.pageCallback({ offset: 0 });
    this.designData = {
      cols: [],
      data: [],
      groupby: "DESIGN NO",
    };
  }

  hotkeys(event) {
    if (this.active) {
    }
  }

  OnSelectcoredesignno($event) {
    //
    this.listSelected.push($event.item.design_no);
    this.filter["design"] = this.listSelected;
    this.filter["design_no"] = "";
  }

  OnSelectnewdesignno($event) {
    //
    this.newlistSelected.push($event.item.design_no);
    this.filter["new_design_no"] = this.newlistSelected;
    this.filter["newdesignno"] = "";
  }

  onChangeAbove(event) {
    if (event.checked == true) {
      this.filter.design_below = false;
    }
  }
  onChangeBelow(event) {
    if (event.checked == true) {
      this.filter.design_above = false;
    }
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else if (nextEl == "applyFilter") {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      this.applyFilter();
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  setData(data) {
    this.data = Object.assign({}, data);
  }

  onCellClick(event, groupby) {
    if (this.filter.groupby == "DESIGN NO") {
      this.filter.groupby = "DESIGN COLOR";

      this.filter["corelist"].push(event.row.design_no);
      this.getAgentYearlyReport();
    }
  }

  onOpenedFilter(): void {
    setTimeout(function () {
      $("#sp-groupby").focus();
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
    }, 100);
  }
  onClickEstimate(check) {
    this.filter.estindicate = check;
  }
  onChangePageSize(limit) {
    this.page.limit = limit;
    this.getAgentYearlyReport();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  brandCombo() {
    let that = this;
    this.combo.brandCombo().then((res: any) => {
      that.brandList = res.data;
    });
  }
  qualityCombo() {
    let that = this;
    this.combo.qualityCombo().then((res: any) => {
      that.qualityList = res.data;
    });
  }

  newDesignCombo() {
    let that = this;
    this.combo.newDesignCombo().then((res: any) => {
      that.newDesignList = res;
    });
  }
  coreDesignCombo() {
    let that = this;
    this.combo.coreDesignCombo().then((res: any) => {
      that.coreDesignList = res;
    });
  }
  typeCombo() {
    let that = this;
    this.combo.typeCombo().then((res: any) => {
      that.typeList = res.data;
    });
  }
  colorCombo() {
    let that = this;
    this.combo.colorCombo().then((res: any) => {
      that.colorList = res.data;
    });
  }
  fitCombo() {
    let that = this;
    this.combo.fitCombo().then((res: any) => {
      that.fitList = res.data;
    });
  }
  styleCombo() {
    let that = this;
    this.combo.styleCombo().then((res: any) => {
      that.styleList = res.data;
    });
  }

  onClickCheck(selected, name, status) {
    if (status == true) {
      selected.push(name);
      this.filter["brand"] = selected;
      //this.fil['brand'] = selected;
    }
    if (status == false) {
      var n = selected.indexOf(name);
      selected = selected.splice(n, 1);
    }
  }
  onClickCheckstyle(selected, name, status) {
    if (status == true) {
      selected.push(name);
      this.filter["style"] = selected;
    }
    if (status == false) {
      var n = selected.indexOf(name);
      selected = selected.splice(n, 1);
    }
  }
  onClickChecktype(selected, name, status) {
    if (status == true) {
      selected.push(name);
      this.filter["type"] = selected;
    }
    if (status == false) {
      var n = selected.indexOf(name);
      selected = selected.splice(n, 1);
    }
  }
  onClickCheckfit(selected, name, status) {
    if (status == true) {
      selected.push(name);
      this.filter["fit"] = selected;
    }
    if (status == false) {
      var n = selected.indexOf(name);
      selected = selected.splice(n, 1);
    }
  }
  onClickCheckquality(selected, name, status) {
    if (status == true) {
      selected.push(name);
      this.filter["quality"] = selected;
    }
    if (status == false) {
      var n = selected.indexOf(name);
      selected = selected.splice(n, 1);
    }
  }
  onClickCheckcolor(selected, name, status) {
    if (status == true) {
      selected.push(name);
      this.filter["color"] = selected;
    }
    if (status == false) {
      var n = selected.indexOf(name);
      selected = selected.splice(n, 1);
    }
  }
  onClickSale(selected, name, status) {
    if (status == true) {
      selected.push(name);
      this.filter["stocktype"] = selected;
    }
    if (status == false) {
      var n = selected.indexOf(name);
      selected = selected.splice(n, 1);
    }
    /*if(selected.length == 1){
            this.filter.stocktype = selected[0];
        }
        else{
            this.filter.stocktype = '';
        }*/
  }
  onClickCore(selected, name, status) {
    if (status == true) {
      selected.push(name);
      this.filter["design_type"] = selected;
    }
    if (status == false) {
      var n = selected.indexOf(name);
      selected = selected.splice(n, 1);
    }
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.getAgentYearlyReport();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    this.getAgentYearlyReport();
  }

  addDateParam(field, filter) {
    if (filter[field] && filter[field] !== null) {
      filter[field] = this.dp.transform(filter[field], "yyyy-MM-dd");
    } else {
      filter[field] = "";
    }
  }
  getAgentYearlyReport(): void {
    let filter = Object.assign({}, this.filter);
    this.addDateParam("mfg_from", filter);
    this.addDateParam("mfg_to", filter);
    this.filter["corelist"] = this.filter.design.concat(
      this.filter.new_design_no
    );
    if (this.filter.stockArray.length == 1) {
      this.filter.stocktype = this.filter.stockArray[0];
    } else {
      this.filter.stocktype = "";
    }
    let params = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      page: "1",
      // name:this.filterData.name,
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      filter: JSON.stringify(filter),
      season_id: this.filter.season_id,
      fin_id: this.filter.fin_id,
    };
    let that = this;
    that.gridOptions = {
      loading: true,
      maxHeight: window.innerHeight - 300 + "px",
      columns: [],
      data: [],
    };

    this.isLoadMask = this.reportService
      .getStockReport(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        that.columns = res.columns;
        that.dataList = res.data;
        that.gridOptions = {
          columns: res.columns,
          data: res.data,
          cols: res.cols,
          loading: false,
        };
        if (that.filter.viewtype == "TILE") {
          that.viewType = "TILE";
        } else {
          that.viewType = "GRID";
        }
        that.designData = {
          cols: res.cols,
          data: res.data,
          filter: that.filter.stocktype,
          groupby: that.filter.groupby,
        };
        for (let i = 0; i < res.data.length; i++) {
          that.designData.data[i].f34 = res.data[i].AF34;
          that.designData.data[i].f36 = res.data[i].AF36;
          that.designData.data[i].f38 = res.data[i].AF38;
          that.designData.data[i].f40 = res.data[i].AF40;
          that.designData.data[i].f42 = res.data[i].AF42;
          that.designData.data[i].f44 = res.data[i].AF44;
          that.designData.data[i].h34 = res.data[i].AH34;
          that.designData.data[i].h36 = res.data[i].AH36;
          that.designData.data[i].h38 = res.data[i].AH38;
          that.designData.data[i].h40 = res.data[i].AH40;
          that.designData.data[i].h42 = res.data[i].AH42;
          that.designData.data[i].h44 = res.data[i].AH44;
        }

        that.page.count = res.total;
        that.refreshData();
        that.printConfig = {
          title: "Stock report",
          columns: that.columns,
          rows: that.dataList,
        };
        that.exceldata = that.getData(res.columns, res.data);
      });
  }

  getData(columns, data) {
    let cols = columns;
    let value = data;
    let rows = [],
      row,
      ind,
      type,
      val,
      rlen = data.length,
      clen = columns.length;

    for (let i = 0; i < data.length; i++) {
      let sno = i + 1;
      row = Object.assign({}, data[i]);
      let newrow = {
        Sno: sno,
      };
      for (let j = 1; j < clen; j++) {
        let type = cols[j].type,
          index = cols[j].index,
          prop = cols[j].prop,
          name = cols[j].name;

        newrow[name] = row[prop];
      }

      rows.push(newrow);
      sno++;
    }
    return rows;
  }

  onChangePhoto(status) {
    if (status == true) {
      this.filter.sizecols = "";
    }
  }

  exportToExcel($event) {
    this.excelService.exportAsExcelFile(this.exceldata, this.title);
  }

  clearFilter(): void {
    this.filterData = {
      name: "",
    };
    this.applyFilter();
  }

  applyFilter(): void {
    //this.filterExpand = false;
    this.filterPanel.close();
    this.filter["corelist"] = this.filter.design.concat(
      this.filter.new_design_no
    );
    if (this.filter.stockArray.length == 1) {
      this.filter.stocktype = this.filter.stockArray[0];
    } else {
      this.filter.stocktype = "";
    }
    if (this.filter.coreArray.length == 1) {
      this.filter.design_type = this.filter.coreArray[0];
    } else {
      this.filter.design_type = "";
    }
    this.viewType = "GRID";
    this.getAgentYearlyReport();
  }

  onbackbutton() {
    this.filter.groupby = "DESIGN NO";
    this.listSelected = [];
    this.newlistSelected = [];
    this.filter["corelist"] = [];
    this.filter["design"] = this.listSelected;
    this.filter.new_design_no = this.newlistSelected;
    this.getAgentYearlyReport();
  }

  onRowSelected($event) {
    let data = Object.assign($event.selected[0]);
    data["fin_id"] = this.filter.fin_id;
    const tabObj = {
      action: "NewTab",
      params: {
        tabParent: "REPORTS",
        tabName: "PartySalesOrderReport",
        type: "order",
        mode: "View",
        data: data,
      },
    };
    this.tabUpdateEvent.emit(tabObj);
  }

  refreshData() {
    let columns = this.columns,
      data = this.dataList,
      row = this.getSummaryRow(data, columns);
    // data.push(row);
    this.page.count = data.length;
    // this.dataList = data;
  }

  getRowClass(event) {
    return event.type == "summary" ? "summary-row" : "";
  }

  getSummaryRow(data, columns) {
    let row = {
      type: "summary",
    };
    for (let i = 0; i < columns.length; i++) {
      let col = columns[i];
      switch (col.summary) {
        case "sum":
          let total = 0;
          for (let j = 0; j < data.length; j++) {
            let dat = data[j];
            total += dat[col.prop];
          }
          row[col.prop] = Math.round(total * 100) / 100;
          break;
        default:
          row[col.prop] = "";
          break;
      }
    }
    return row;
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/report/StockReport/StockReport.ts